import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/testimonials';
export function Testimonials() {
  return <section aria-label="Testimonios" className="bg-ink" data-id="element-150" data-mp="3fze2zvj28zum">
      <div className="mx-auto max-w-6xl px-5 pb-16 pt-12 sm:pb-20" data-id="element-151" data-mp="3fxuly2pkykrs">
        <h2 className="text-center font-display text-3xl font-black text-white sm:text-4xl" data-id="element-152" data-mp="3azjc3rzaca9k">
          💬 Lo que dicen las que ya lo aplicaron
        </h2>
        <div className="mt-10 grid w-full grid-cols-1 gap-5 sm:mt-12 md:grid-cols-3 md:gap-6" data-id="element-153" data-mp="36wmqrtid201x">
          {testimonials.map((t, i) => <motion.figure key={t.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex min-h-[230px] flex-col rounded-2xl border border-white/10 bg-ink-2 p-6 sm:min-h-[250px]" data-id="element-154" data-mp="2x006p6xuzd0y" data-mpi={i}>
              <div className="flex gap-0.5 text-bordo-light" aria-label="5 de 5 estrellas" data-id="element-155" data-mp="h5oox8u9426d">
                {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-156" data-mp="m2on6xkv00mx" data-mpi={k} />)}
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] leading-relaxed text-white/80" data-id="element-157" data-mp="c6bthzpbdms6">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-white/10 pt-4" data-id="element-158" data-mp="zx7tvl7u5qb1">
                <img src={t.img} alt={t.name} className="h-11 w-11 rounded-full object-cover ring-2 ring-plata/50" data-id="element-159" data-mp="14ur6yhssrx1e" />
                <div data-id="element-160" data-mp="v4em0oh2m1uq">
                  <div className="text-sm font-bold text-white" data-id="element-161" data-mp="v3mt5leuyi85">{t.name}</div>
                  <div className="text-xs text-white/50" data-id="element-162" data-mp="1itqvzqk82dy3">📍 {t.location}</div>
                </div>
              </figcaption>
            </motion.figure>)}
        </div>
      </div>
    </section>;
}